import React, { useEffect, useState } from "react";
import Images from "../../assets/images/index";
import Icons from "../../assets/icons/index";
import { Link, Navigate, useNavigate, useParams } from "react-router-dom";
import { getCurrent, logoutDevice } from "../../restApi/api";
import { decrypt, decryptdata, encrypt } from "../../utils/crypto";
import { firebaseData } from "../../firebase";
import moment from "moment";
import { getAnalytics, setUserId, setUserProperties } from "firebase/analytics";
import { authorizationCheck } from "../../utils/logout";
import Loader from "../common/Loader/Loader";
import { toast, ToastContainer } from "react-toastify";
import Modal from "react-bootstrap/Modal";

export default function AccountsHome(){
    const navigate = useNavigate();
    const { name } = useParams();
    const [data, setData] = useState(null);
    let [loader,setloader]=useState(true)
    const [config, setConfig] = useState();
	const [remoteLoading, setRemoteLoading] = useState(true);
    const [logoutShow, setLogout] = useState();
    const showLogout = () => setLogout(true);
    const logoutHide = () => setLogout(false);

    const firebaseStore=async(data)=>{
		let activePackageList = data.activePackage
        let sizeOfActiveList = activePackageList?.length
		let activePackage=[]
		for(let i=0;i<sizeOfActiveList;i++){
		    activePackage.push(data.activePackage[i].packageId)
		}
		let paid
		if (sizeOfActiveList > 0){
			paid=true
		}else{
			paid=false
		}
		var noOfDays = 0
		if(data.trialEndDate){
			let end_Date= moment(new Date())
			let start_Date = moment(data.trialEndDate); // add date in the yy / mm / dd format.
            noOfDays = end_Date.diff(start_Date, 'days');
		}else{
			noOfDays= 0
		}
		const analytics = getAnalytics()
			setUserId(analytics,data._id);
			setUserProperties(analytics, 
				{ 
					user_id:data._id,
					name: data.name ,
					isNotification:data.isNotification,
					email:data.email,
					mobileNo:data.mobileNo,
					createdAt:data.createdAt,
					Version:data.version,
					countryCode:data.countryCode,
					Year:data?.batch?.year,
					country:data?.address?.country,
					collegeState:data?.address?.collegeState,
					collegeCity:data?.address?.collegeCity,
					collegeName:data?.address?.collegeName,
					course:data.preparingFor,
					collegeYear:data.collegeYear,
					isFreeTrialActivated:noOfDays>0?true:false,
					packages:activePackage,
					paidUser:paid,
					role:data.role,
					trialEndDate:data.trialEndDate
				}
				);
    }
    const currentList=async ()=>{
        await getCurrent()
            .then(response => {
          return response.json()
        })
            .then(data => {
            let req= JSON.parse(decrypt(data))
            let user=req.data.result
            let profileDetails={
                id:user._id,
                name: user.name,
                avatar : user.avatar,
                country:user?.address?.country,
                email: user.email,
                collegeCity:user?.address?.collegeCity,
                collegeName:user?.address?.collegeName,
                collegeState:user?.address?.collegeState,
                collegeYear:user.collegeYear,
                batch:user?.batch?._id,
                mobileNo: user.mobileNo,
                preparingFor:user.preparingFor
            };
            firebaseStore(req.data.result)
            localStorage.setItem('profileDetails',encrypt(JSON.stringify(profileDetails)))
            setData(profileDetails)
            setloader(false)
            }).catch((error) => {
               setloader(false)
        })
    }
    const navigateTab =(title,url)=>{
        if(title==='My Active Plans'){
            navigate('/account/myActivePlan')
        }
        if(title==='My Orders'){
            navigate('/account/myorder')
        }
        if(title==='My Bookmark'){
            navigate('/account/mybookmarks')
        }
        if(title==='My Saved Videos'){
            navigate('/account')
        }
        if(title==='Settings'){
            navigate('/account/setting')
        }
        if(title==='Contact Us'){
            navigate('/account/contactUs')
        }
        if(title==='About us'){
         window.open(url, "_blank");
        }
        if(title==='Privacy Policy'){
        window.open(url, "_blank");
        }
    }  
    const gotosubscription=()=>{
        navigate('/package')
    }

    const logoutUser = async () => {
        setloader(true)
        let user=JSON.parse(decrypt(localStorage.getItem('profileDetails')))
        let data={
            "deviceId": decryptdata(localStorage.getItem('dId')),
            "isSelf": true,
            "isAllLogout": false,
            "userId": user?.id
        }
        await logoutDevice(data)
          .then(response => {
            return response.json()
          })
          .then(data => {
            let req= JSON.parse(decrypt(data))
              if (req.data.code == 1) {
                navigate('/onboarding/login')
                var datasetString = JSON.stringify(null)
                document.cookie = "dataset=" + encodeURIComponent(datasetString) + "; path=/";
                localStorage.removeItem('dId')
                localStorage.removeItem('profileDetails')
                localStorage.removeItem('token')
                localStorage.removeItem('version')
                localStorage.removeItem('language')
                localStorage.clear()
                setloader(false)                  
              }
              else if(req.data.code==402){
                 authorizationCheck(navigate)
              }
          }).catch((error) => {
            setloader(false)
          })
    }
    const showToast = (message) => {
        toast.success(message);
    };
    useEffect(() => {
        setloader(true)
        currentList()
            const getConfigData = async () => {
              try {
                const remoteData = await firebaseData('account_content'); // Replace 'your_config_key' with the actual key for the configuration value you want
                setConfig(JSON.parse(remoteData));
                setRemoteLoading(false);
              } catch (error) {
                console.error('Error fetching remote data:', error);
                setRemoteLoading(false);
              }
            };
        
            if (typeof window !== 'undefined') {
              getConfigData();
            }    
    }, []);
    if (loader) {return (<><Loader/></>)}
    return (
        <>
        <div className="main_wrapper">
            <div className="breadcrumbs">
                <ul className="breadcrumb">
                    <li className="breadcrumb-item"><a >Home</a></li>
                    <li className="breadcrumb-item active"><a >Account</a></li>
                </ul>
            </div>
            <section className="videoLayer_wrapper account_main_wrapper section_side_padding">
                <div className='row'>
                    <div className="col-lg-8 col-md-7 col-sm-12">
                        <div className="subjects_wrapper">
                            <div className="user_info_wrappper d-flex">
                                <div className="user_inner_info d-flex align-items-center">
                                    <figure className="user_img">
                                        <img src={data&&data.avatar?data&&data.avatar:Icons.UserPic}  alt="" className="img-fluid"/>
                                    </figure>
                                    <div className="user_details">
                                        <h5>{data?data.name:""}</h5>
                                        <p>{data?data.preparingFor:""}</p>
                                    </div>
                                </div>
                                <div className="edit_profile">
                                    <span className="edit_text">
                                    <Link to={'/account/editProfile'} >
                                        <img src={Icons.Edit} alt="" className="img-fluid"/>Edit Profile
                                    </Link>
                                    </span>
                                </div>
                            </div>
                            <div className="account_baner" onClick={gotosubscription}>
                                <img src={config&&config[0]?.section[0].icon}></img>
                            </div>
                            <div className="accounts_options_wrapper">
                                <ul type="none" className="options_child d-flex flex-wrap">
                                    {
                                       config&& config[1]?.section.map(obj=>(
                                        <li className="border_bottom" onClick={()=>navigateTab(obj.title,'')}>
                                            <div className="options_body_wrapper d-flex align-items-center">
                                                <div className="options_inner_body d-flex align-items-center">
                                                    <figure className="opt_icons">
                                                        <img src={obj.icon} alt="" className="img-fluid"/>
                                                    </figure>
                                                    <div className="active_plans">
                                                        <h6>{obj.title}</h6>
                                                    </div>
                                                </div>
                                                <div className="arrow_plans">
                                                    <img src={Icons.VideoArrow} alt="" className="img-fluid"/>
                                                </div>
                                            </div>
                                        </li>
                                        ))
                                    }
                                    {/* <li className="border_bottom">
                                        <div className="options_body_wrapper d-flex align-items-center">
                                            <div className="options_inner_body d-flex align-items-center">
                                                <figure className="opt_icons">
                                                    <img src={Icons.Orders} alt="" className="img-fluid"/>
                                                </figure>
                                                <div className="active_plans">
                                                    <h6>My Order</h6>
                                                </div>
                                            </div>
                                            <div className="arrow_plans">
                                                <Link to={'/account/myorder'}>
                                                <img src={Icons.VideoArrow} alt="" className="img-fluid"/>
                                                </Link>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="options_body_wrapper d-flex align-items-center">
                                            <div className="options_inner_body d-flex align-items-center">
                                                <figure className="opt_icons">
                                                    <img src={Icons.AccBookmarks} alt="" className="img-fluid"/>
                                                </figure>
                                                <div className="active_plans">
                                                    <h6>My Bookmark</h6>
                                                </div>
                                            </div>
                                            <div className="arrow_plans">
                                            <Link to={'/account/mybookmarks'}>
                                                <img src={Icons.VideoArrow} alt="" className="img-fluid"/>
                                            </Link>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="options_body_wrapper d-flex align-items-center">
                                            <div className="options_inner_body d-flex align-items-center">
                                                <figure className="opt_icons">
                                                    <img src={Icons.Settings} alt="" className="img-fluid"/>
                                                </figure>
                                                <div className="active_plans">
                                                    <h6>Settings</h6>
                                                </div>
                                            </div>
                                            <div className="arrow_plans">
                                            <Link to={'/account/setting'}>
                                                <img src={Icons.VideoArrow} alt="" className="img-fluid"/>
                                            </Link>
                                            </div>
                                        </div>
                                    </li> */}
                                </ul>
                            </div>
                        </div>
                        <div className="subjects_wrapper">
                            <div className="user_info_wrappper information_options">
                                <h5>Information</h5>
                            </div>
                            <div className="accounts_options_wrapper infoOptions_wrapper">
                                <ul type="none" className="options_child d-flex flex-wrap">
                                    {
                                        config&& config[2]?.section.map(obj=>(
                                    <li className="border_bottom" onClick={()=>navigateTab(obj.title,obj.url)}>
                                        <div className="options_body_wrapper d-flex align-items-center">
                                            <div className="active_plans">
                                                <h6>{obj.title}</h6>
                                            </div>
                                            <div className="arrow_plans">
                                                <img src={Icons.VideoArrow} alt="" className="img-fluid"/>
                                            </div>
                                        </div>
                                    </li>
                                        ))
                                    }
                                    {/* <li className="border_bottom">
                                        <div className="options_body_wrapper d-flex align-items-center">
                                            <div className="active_plans">
                                                <h6>Contact Us</h6>
                                            </div>
                                            <div className="arrow_plans">
                                                <img src={Icons.VideoArrow} alt="" className="img-fluid"/>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="options_body_wrapper d-flex align-items-center">
                                            <div className="active_plans">
                                                <h6>Rate Us</h6>
                                            </div>
                                            <div className="arrow_plans">
                                                <img src={Icons.VideoArrow} alt="" className="img-fluid"/>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="options_body_wrapper d-flex align-items-center">
                                            <div className="active_plans">
                                                <h6>Privacy Policy</h6>
                                            </div>
                                            <div className="arrow_plans">
                                                <img src={Icons.VideoArrow} alt="" className="img-fluid"/>
                                            </div>
                                        </div>
                                    </li> */}
                                </ul>
                            </div>
                        </div>
                        <div className="subjects_wrapper" >
                            <div className="logout_wrapper d-flex align-items-center">
                                <div className="logout_body d-flex align-items-center" onClick={showLogout}>
                                    <figure className="logout_img">
                                        <img src={Icons.Logout} alt="" className="img-fluid"/>
                                    </figure>
                                    <div className="logout_text">
                                        <h6>Log Out</h6>
                                    </div>
                                </div>
                                <div className="log_arrow">
                                    <img src={Icons.VideoArrow} alt="" className="img-fluid"/>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-4 col-sm-12">
                        {/* <div className="videos_wrapper">
                            <div className="buy_packages d-flex align-items-center">
                                <div className="package_text">
                                    <h6>Buy Package</h6>
                                    <p>Buy Package to unlock content and Start Learning</p>
                                </div>
                                <div className="package_img">
                                    <img src={Images.Package} alt="" className="img-fluid"/>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
            </section>
        </div>
        <Modal
        show={logoutShow}
        onHide={logoutHide}
        backdrop="static"
        className="detail_modal report_modal device_reached"
        centered
    >
            <Modal.Body>
                <div className="account_option_wrapper">
                    <div className="cross_icon text-right">
                        <img src={Icons.ModalCross} alt="" className="img-fluid" onClick={logoutHide}/>
                    </div>
                    <div className="account_header text-center">
                        <h6>Are you sure you want to Logout?</h6>
                        <p>If you logout then all your saved videos will be deleted and all your settings will be reset.</p>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div className="rating_submit">
                    <button type="button" className="btn btn_theme btn_border" onClick={logoutHide}>Cancel</button>
                    <button type="submit" className="btn btn_theme" onClick={logoutUser}>Yes, Logout</button>
                </div>
            </Modal.Footer>
        </Modal>
        </>
    )
}